import React, {Component} from 'react';
import EventDetailsFilter from './EventDetailsFilter';
import PassItem from '../../components/Credentials/PassItem';
import PassItemModal from '../../components/Credentials/PassItemModal';
import { v4 } from 'node-uuid';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';


class EventDetails extends Component {

  render() {
    const {cancelCredential, eventDetails} = this.props;
    const {filter, assignedCredentials, name, schedule, trackName} = eventDetails;
    const filteredEventDetails = filter === 'all' ? assignedCredentials : eventDetails[CREDENTIAL_TYPE_LABELS[filter]["event_details_key"]];

    return (
      <div>
        <EventDetailsFilter {...this.props} />
        {filteredEventDetails.map(item => {
          const key = v4();
          return (
            <div key={key}>
              <PassItem
                onClick={() => this.refs[key].showModal()}
                item={item}
              />
              <PassItemModal
                ref={key}
                name={name}
                cancelCredential={cancelCredential}
                schedule={schedule}
                trackName={trackName}
                item={item}
              />
            </div>
          )
        })}
      </div>
    );
  }
}

export default EventDetails;



// WEBPACK FOOTER //
// ./src/components/Events/EventDetails.js